module.exports = __webpack_public_path__ + "components/modal-app-popup/static/safari-icon-9ff597d627757c2087792d219b014837.webp";